import { authHeader } from '../_helpers';

export const userService = {
    login,
    loginWToken,
    logout,
    register,
    getAll,
    getById,
    update,
    changePassword,
    forgotPassword,
    sendMessage,
    delete: _delete
};

function login(email, password, first_name = '', last_name = '', cabinet = [], favorites = [], keyIngredients = [], _id = '', editProfile = false) {

    let requestOptions = {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({email, password, first_name, last_name, cabinet, favorites, keyIngredients, _id})
    };

    return fetch('/api/signin', requestOptions)
        .then(response => {
            if (!response.ok) { 
                return Promise.reject(response.statusText);
            }

            return response.json();
        })
        .then(userRaw => {
            let user = {};
        // login successful if there's a jwt token in the response
        if (userRaw && userRaw.token) { //  && user.token
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('user', JSON.stringify(userRaw));
            user = userRaw;
        } else if (userRaw) {
            let userExisting = JSON.parse(localStorage.getItem('user'));
            user = userRaw;
            user.token = userExisting.token;
            localStorage.setItem('user', JSON.stringify(user));
        }

    return user.user;
        });
}

function loginWToken(token) {
    let requestOptions = {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({token})
    };

    return fetch('/api/oneTimeLogin', requestOptions)
        .then(response => {
          console.log("Here is the response:", response);
    if (!response.ok) {
        return Promise.reject(response.statusText);
    }

    return response.json();
})
.then(user => {
    // login successful if there's a jwt token in the response
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(user));

    return user.user;
});
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch('/api/users', requestOptions).then(handleResponse);
}

function getById(_id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch('/users/' + _id, requestOptions).then(handleResponse);
}

function register(user) {
  // THIS IS NO LONGER USED... REGISTER COMBINED WITH LOGIN.  PLEASE DELETE in JANUARY 2019
    const requestOptions = {
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };
    requestOptions.method = user._id ? 'PUT' : 'POST';

    return fetch('https://www.delete_2019.com/Bottleneck-City/api/users/register' + (user._id ? '/' + user._id : ''), requestOptions).then(handleResponse);
}

function update(user) {
    let headers = authHeader();
    headers['Content-Type'] = 'application/json'
    const requestOptions = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(user)
    };
    
    return fetch('/api/update', requestOptions)
        .then(response => {
          if (!response.ok) {
        return Promise.reject(response.statusText);
    }

    return response.json();
    })
    .then(user => {
        
        // login successful if there's a jwt token in the response
        let updatedUser = {};
        if (user) {
            let updatedUser = JSON.parse(localStorage.getItem('user'));
            updatedUser.user = user;
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('user', JSON.stringify(updatedUser));
        }
        return user;
    });
}

function changePassword(user) {
    let headers = authHeader();
    headers['Content-Type'] = 'application/json'
    const requestOptions = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(user)
    };

    return fetch('/api/changePassword', requestOptions)
        .then(response => {

            if (!response.ok) {
        return Promise.reject(response.statusText);
    }

    return response.json();
})
.then(user => {

    if (user && user.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(user));
    }

    return user.user;
});
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(_id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch('/api/user/' + _id, requestOptions).then(handleResponse);
}

function forgotPassword(email) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({email})
    };

    return fetch('/api/forgotPassword', requestOptions).then(handleResponse);
}

function sendMessage(contactFormFields) {
    const requestOptions = {
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(contactFormFields),
        method: 'POST'
    };

    return fetch('/api/sendMessage', requestOptions).then(handleResponse);
}

function handleResponse(response) {
    if (!response.ok) {
        return Promise.reject(response.statusText);
    }


    return response.json();
}


// WEBPACK FOOTER //
// ./src/_services/user.service.js